import axios from 'axios'

class ProductTemplatesQueries {
    fetchProductTemplatesWithQueryString(queryString = '') {
        const url = `/product-templates/product-templates${queryString ? `?${queryString}` : ''}`
        return axios.get(url)
    }

    fetchProductTemplate(productTemplateId) {
        return axios.get(`/product-templates/product-templates/${productTemplateId}`)
    }

    createProductTemplate(payload) {
        return axios.post('/product-templates/product-templates', payload)
    }

    updateProductTemplate(productTemplateId, payload) {
        return axios.put(`/product-templates/product-templates/${productTemplateId}`, payload)
    }

    deleteProductTemplate(productTemplateId) {
        return axios.delete(`/product-templates/product-templates/${productTemplateId}`)
    }

    fetchProductionFileInPaths() {
        return axios.get('/files/dicts/production-file-in-path')
    }

    fetchFoldingTypes() {
        return axios.get('/foldings/folding-types')
    }
}

export default new ProductTemplatesQueries()
